<template>
    <v-row justify-md="center" wrap>

        <v-data-table :headers="headers" :items="items" sort-by="id" class="elevation-1 secondary mx-auto"
            :mobile-breakpoint="activateBreakpoint" :search="search">
            <template v-slot:top v-if="showHeader">

                <v-toolbar color="primary" flat>
                    <slot v-if="showCardTitle" name="crdTitle">
                        <v-list-item-title class="text-h6 mb-4 tertiary--text">
                            {{ cardTitle }}
                            <v-spacer></v-spacer>

                        </v-list-item-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-card>
                                        <v-btn color="primary" @click="exportToExcel"> Exportar </v-btn>
                                    </v-card>
                    </slot>

                    <template v-slot:top v-if="showSearch">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                            class="ma-2 px-8" color="secondary"></v-text-field>
                    </template>

                </v-toolbar>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <template v-if="hasActions">
                    <v-tooltip v-for="(action, index) in actions" :key="index" bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" dark v-on="on" @click="handleClick(item, action.action)">
                                {{ action.icon }}
                            </v-icon>
                        </template>
                        <span>{{ action.tooltip }}</span>
                    </v-tooltip>
                </template>
            </template>
            <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip v-for="(action, index) in actions" :key="index" bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon small class="mr-2" dark v-on="on" @click="handleClick(item, action.action)">
                            {{ action.icon }}
                        </v-icon>
                    </template>
                    <span>{{ action.tooltip }}</span>
                </v-tooltip>
            </template> -->
        </v-data-table>
    </v-row>
</template>

<script>
// import VueJsonExcel from 'vue-json-excel'

import * as XLSX from "xlsx"
import { saveAs } from "file-saver"

export default {
    props: {
        showHeader: {
            default: true
        },
        showCardTitle: {
            default: false
        },
        cardActions: {
            default: 'crdActions',
        },
        cardShowActions: {
            default: true,
        },
        cardTitle: {
            default: 'Materialfy Basic Card',
        },
        activateBreakpoint: {
            default: 0
        },
        showSearch: {
            default: true
        },
        actions: {
            type: Array,
            required: true,
            default: () => []
        },
        hasActions: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    components: {
        // VueJsonExcel,
    },
    data: () => ({
        snack: false,
        snackColor: "",
        snackText: "",
        max25chars: (v) => v.length <= 25 || "Input too long!",
        pagination: {},
        userList: [],
        userList2: [],
        apiEndpoint: "users",
        apiEndpoint2: "users?page=2",
        checkboxAdmin: true,
        checkboxActive: false,
        rowsAmount: [
            15,
            20,
            25,
            { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
        ],
        dialog: false,
        search: "",
        headers: [],
        items: [],
        editedIndex: -1,
        //second table
        dialogDelete: false,
        jsonFields: {
            ID: 'id',
            Name: 'name',
            Value: 'value',
        },
    }),

    computed: {
        // filteredActions() {
        //     return (item) => this.actions.filter(action => action.condition(item));
        // }
    },

    watch: {
        //when dialog is updated this watcher returns the updated value only if the value is truthy, else it calls this.close() method
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        //once the table list is loaded, load the headers
        userList() {
            this.getHeaders();
        },
    },
    // called when page is created before dom to load data from api
    created() {

    },

    methods: {
        handleClick(item, action) {
            // console.log(item)
            this.$emit('action-clicked', { item, action });
        },

        // object.assign fills in the empty object with the properties of item
        editItem(item, dialogbox = true) {
            /* sets the index that controls the title text in the new item pop up
            this updates the editedIndex from being -1 to whatever the index of the table item is that you are editing
            this function is called by the @click edit icons in table actions
            */
            this.editedIndex = this.userList.indexOf(item);
            item.isAdmin = this.checkboxAdmin;
            item.isActive = this.checkboxActive;
            // makes a new object with the same properties as the item object that is able to be accessed easily by methods and others
            this.editedItem = Object.assign({}, item);
            //opens the dialog editing box connected to v-dialog v-model="dialog"
            this.dialog = dialogbox;
        },
        /* This is a dynamic method that handles sending vuex actions to call different axios endpoints with different methods
        you get the index of the item passed in via another method, 
        you use the edited item created in the method that called this one and assign to tableITem to use later
        you then dispatch the updateTableItem action with the new edited from html item
        you then remove the item from the list as well to update the table
         */
        //this is really only called by delete right now, to create or update we use save(). But it can be expanded with if/switch
        callTableAction(item, endpoint, method) {
            const index = this.userList.indexOf(item);
            let tableItem = this.editedItem;
            this.$store
                .dispatch("updateTableItem", { endpoint, tableItem, method })
                .then(() => {
                    this.userList.splice(index, 1); //remove/delete the item from the array the table is using
                    this.saveInline(); //calls snackbar noticiation
                })
                .catch((error) => {
                    console.log(error);
                    this.cancelInline; //calls snackbar noticiation
                });
        },
        // this sets the item, url path endpoint and the type of api method(delete) for calltableAction
        deleteItem(item) {
            //this causes config dialog with 'ok'/'cancel' and if ok is hit this runs
            if (confirm("Are you sure you want to delete this item?")) {
                this.editedItem = Object.assign({}, item);
                let endpoint = `users/delete/${this.editedItem.username}`;
                let method = "delete";
                // calls callTableActions which is a method above that handles calling axios via vuex actions
                this.callTableAction(item, endpoint, method);
            }
        },
        // closes the dialog pop up and resets index until its opened again
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1; // resets the index that controls the title text in the new item pop up
            }, 300);
        },

        save() {
            //if editedIndex is greater than -1 then the item we are trying to save is an already exisiting item, so we update the table differently
            //when you open the editItem menu it sets the index to the items index, which then is used here to determine what to do
            if (this.editedIndex > -1) {
                let tableItem = this.editedItem;
                let endpoint = `users/update/${this.editedItem.username}`;
                let method = "patch";
                this.$store
                    .dispatch("updateTableItem", { endpoint, tableItem, method })
                    .then(() => {
                        // merge both objects to update the original object in userList to update table
                        Object.assign(this.userList[this.editedIndex], this.editedItem);
                        this.saveInline(); //calls snackbar noticiation
                    })
                    .catch((error) => {
                        console.log(error);
                        this.cancelInline; //calls snackbar noticiation
                    });
            } else {
                //if the editedIndex isnt greater than -1 then its a new item/user so we do a different set of actions to add a new item
                let tableItem = this.editedItem;
                let endpoint = `users/new-user`;
                let method = "post";
                this.$store
                    .dispatch("updateTableItem", { endpoint, tableItem, method })
                    .then(() => {
                        // instead of merging objects in userList we add new object to user list with .push()
                        console.log("new user");
                        this.userList.push(this.editedItem);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.cancelInline; //calls snackbar noticiation
                    });
            }
            this.close();
        },

        // toasts/snackbar/pop-up messages when you pressactions
        saveInline() {
            this.snack = true;
            this.snackColor = "success";
            this.snackText = "Data saved";
        },
        cancelInline() {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Canceled";
        },
        reset() {
            this.snack = true;
            this.snackColor = "success";
            this.snackText = "Data reset to default";
        },
        openInline() {
            this.snack = true;
            this.snackColor = "info";
            this.snackText = "Dialog opened";
        },
        closeInline() {
            console.log("Dialog closed");
        },
        exportToExcel() {
            const worksheet = XLSX.utils.json_to_sheet(this.items);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const data = new Blob([excelBuffer], { type: "application/octet-stream" });
            saveAs(data, "datos.xlsx");
        }
    },
};
</script>

<style>
table.v-table thead tr {
    color: red !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
